// extracted by mini-css-extract-plugin
module.exports = {"route":"SelfTripCard_route__2l3iX","from":"SelfTripCard_from__17pGq","header":"SelfTripCard_header__2CL6n","tripcard":"SelfTripCard_tripcard__2PMFR"};